import Angle from "../../../../../../../src/entities/Angle/Angle";
import { AnglePoints, Coord } from "../../../../../../../src/types/Interface";
import { SupplAngle } from "../../../entities/SupplAngleLine";
import getDistanceBtwPoints from "../../../../../../../src/utils/getDistanceBtwPoints";
import calcGuideLinePoints from "../../../helpers/calcGuideLinePoints";
import calcAngles from "../../../../../../../src/utils/math/calcAngles";
import { generateAngles } from "../../../../../../../src/utils/generator/generateAngles";


export function drawAngle(angle: Angle, p: AnglePoints, degree: number, clockwise: boolean) {
  const { startRadian, endRadian } = calcAngles(p.curr, p.prev, p.next);
  const smllDistance = Math.min(getDistanceBtwPoints(p.curr, p.prev), getDistanceBtwPoints(p.curr, p.next));
  angle.smallDistance = Math.floor(smllDistance);
  angle.draw(p.curr, startRadian, endRadian, degree, clockwise);
  angle.x = p.curr.x;
  angle.y = p.curr.y;
  angle.rotation = 0;
}

export function drawSupplAngle(supplAngle: SupplAngle, p: AnglePoints, degree: number, clockwise: boolean, isFirst: boolean) {
  const { startRadian, endRadian } = calcAngles(p.curr, p.prev, p.next);

  drawAngle(supplAngle, p, degree, clockwise);
  supplAngle.x = supplAngle.coord.x;
  supplAngle.y = supplAngle.coord.y;
  supplAngle.AngleValue.visible = false;
  supplAngle.rotation = isFirst ? Math.PI - startRadian : 0 - endRadian;
}

export function drawGuideAngles(angle1: Angle, angle4: Angle, degrees: number[], [p1, p2, p3, p4]: Coord[], clockwise: boolean) {
  const points = calcGuideLinePoints(p3, p2, 200);
  const points1 = calcGuideLinePoints(p2, p3, 200)

  const p = {
    curr: p3,
    prev: p4,
    next: points[1]
  }
  const pt1 = {
    curr: p2,
    prev: p1,
    next: points1[1]
  }
  const anglef = generateAngles(p, clockwise);
  const angles = generateAngles(pt1, clockwise);

  drawAngle(angle1, p, degrees[0], clockwise);
  drawAngle(angle4, pt1, degrees[1], !clockwise);
}
